<script>
import VueApexCharts from 'vue-apexcharts'

export default {
	name: 'PoolsTab',
	components: { VueApexCharts },
	props: {
		// common
		hasActiveFilters: { type: Boolean, default: false },
		activeFilters: { type: Array, default: () => [] },
		isBinMode: { type: Boolean, default: false },
		binSearched: { type: Boolean, default: false },
		loadingPools: { type: Boolean, default: false },
		usersByPoolSeries: { type: Array, default: () => [] },
		usersByPoolOptions: { type: Object, default: () => ({}) },
		tradesByPoolSeries: { type: Array, default: () => [] },
		tradesByPoolOptions: { type: Object, default: () => ({}) },
		fishVolumeByPoolSeries: { type: Array, default: () => [] },
		fishVolumeByPoolOptions: { type: Object, default: () => ({}) },
	},
}
</script>

<template>
	<div>
		<!-- New pool-distribution diagrams (3) -->
		<div class="mb-8" v-if="!isBinMode || !binSearched">
			<h3 class="font-main font-semibold text-[18px] text-main mb-4">
				{{ $t('titles.users_by_pools') || 'Статистика регистрации субъектов по бассейнам' }}
			</h3>
			<!-- Active Filters Display -->
			<div v-if="hasActiveFilters" class="mb-3">
				<div class="flex flex-wrap gap-2">
					<div
						v-for="(filter, index) in activeFilters"
						:key="index"
						class="bg-blue-50 border border-blue-200 rounded-full px-3 py-1 text-sm text-blue-700 flex items-center gap-2"
					>
						<svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
							<path
								fill-rule="evenodd"
								d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
								clip-rule="evenodd"
							></path>
						</svg>
						<span>{{ filter }}</span>
					</div>
				</div>
			</div>
			<div v-if="loadingPools" class="flex items-center justify-center h-[300px]">
				<v-preloader :message="{ status: null, text: null }"></v-preloader>
			</div>
			<VueApexCharts
				v-else-if="usersByPoolSeries.length"
				type="pie"
				height="350"
				:options="usersByPoolOptions"
				:series="usersByPoolSeries"
			></VueApexCharts>
		</div>

		<div class="mb-8" v-if="!isBinMode || !binSearched">
			<h3 class="font-main font-semibold text-[18px] text-main mb-4">
				{{ $t('titles.trades_by_pools') || 'Всего записей в промысловый журнал по бассейнам' }}
			</h3>
			<!-- Active Filters Display -->
			<div v-if="hasActiveFilters" class="mb-3">
				<div class="flex flex-wrap gap-2">
					<div
						v-for="(filter, index) in activeFilters"
						:key="index"
						class="bg-blue-50 border border-blue-200 rounded-full px-3 py-1 text-sm text-blue-700 flex items-center gap-2"
					>
						<svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
							<path
								fill-rule="evenodd"
								d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
								clip-rule="evenodd"
							></path>
						</svg>
						<span>{{ filter }}</span>
					</div>
				</div>
			</div>
			<div v-if="loadingPools" class="flex items-center justify-center h-[300px]">
				<v-preloader :message="{ status: null, text: null }"></v-preloader>
			</div>
			<VueApexCharts
				v-else-if="tradesByPoolSeries.length"
				type="pie"
				height="350"
				:options="tradesByPoolOptions"
				:series="tradesByPoolSeries"
			></VueApexCharts>
		</div>

		<div class="mb-8" v-if="!isBinMode || !binSearched">
			<h3 class="font-main font-semibold text-[18px] text-main mb-4">
				{{ $t('titles.volume_by_pools') || 'Общий объем рыбы по бассейнам' }}
			</h3>
			<!-- Active Filters Display -->
			<div v-if="hasActiveFilters" class="mb-3">
				<div class="flex flex-wrap gap-2">
					<div
						v-for="(filter, index) in activeFilters"
						:key="index"
						class="bg-blue-50 border border-blue-200 rounded-full px-3 py-1 text-sm text-blue-700 flex items-center gap-2"
					>
						<svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
							<path
								fill-rule="evenodd"
								d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
								clip-rule="evenodd"
							></path>
						</svg>
						<span>{{ filter }}</span>
					</div>
				</div>
			</div>
			<div v-if="loadingPools" class="flex items-center justify-center h-[300px]">
				<v-preloader :message="{ status: null, text: null }"></v-preloader>
			</div>
			<VueApexCharts
				v-else-if="fishVolumeByPoolSeries.length"
				type="pie"
				height="350"
				:options="fishVolumeByPoolOptions"
				:series="fishVolumeByPoolSeries"
			></VueApexCharts>
		</div>
	</div>
</template>

<style scoped></style>
